/* eslint-disable complexity */
/* eslint-disable no-undef */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect } from "react";
import styles from "./styles.css";
import querystring from "querystring";
import PropTypes from "prop-types";
import ReviewSchema from "../../shared/review-schema";
import { Text } from "@cars24/turbo-web/lib/text";
import Rating from "../../shared/react-rating-wrapper";
import IconStar from "../../shared/icon-star";
import {
    getParticularDay,
    getMonth
} from "../../../utils/helpers/get-day-from-date";
import MetaTagsReviews from "../../shared/meta-tags-reviews";
import { getVisiblePages } from "./pagination.utl";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import NotFound from "../../shared/page-not-found";
import BreadcrumbList from "../../shared/breadcrumb-list";
import { appUrl } from "../../../constants/url-constants";

const CustomerReviews = ({ list, average, total, isSSR, showImg, showDate, getCustomerReviewsConnect, history }) => {
    const recieveParams = () => {
        const { location: { search } } = history;
        return search && querystring.parse(search.replace(/\?/g, ""));
    };
    const { tokens } = useTokens();
    const queryParams = recieveParams();
    const currentPage = queryParams.page || 1;
    const pageSize = 10;
    const totalPages = Math.ceil(total / pageSize);

    const visiblePages = getVisiblePages(Number(currentPage), totalPages);

    useEffect(() => {
        if (!isSSR) {
            const payload = {
                page: Number(currentPage),
                size: 10
            };
            getCustomerReviewsConnect(payload);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    const generatePageLink = (page) => {
        return `/used-car-valuation/customer-reviews?page=${page}`;
    };

    const computeBreadcrumbList = () => {
        const breadcrumbList  = [{
            displayText: "Sell car",
            redirectURL: "/sell-used-cars/"
        },
        {
            displayText: `Used Car Valuation`,
            redirectURL: "/used-car-valuation/"
        },
        {
            displayText: `Reviews`,
            redirectURL: ""
        }];
        return breadcrumbList;
    };

    const onBreadcrumbClick = ({ item }) => {
        if (item === "home") {
            window.location.href = `${appUrl()}/`;
        } else {
            window.location.href = `${appUrl()}${item.redirectURL}`;
        }
    };

    if (!list.length) return <NotFound />;

    return (
        <>
            <MetaTagsReviews />
            <div>
                {list.length > 0 && (
                    <div styleName={"styles.testimonialWrap"}>
                        <div styleName={"styles.rattingHeader"}>
                            <div styleName={"styles.backarrow"}>
                                <Text
                                    align="left"
                                    as="h1"
                                    fontWeight="semibold"
                                    size="450"
                                    transform="none"
                                    color={tokens.text_default_text_primary}
                                >
                                User Reviews & Ratings
                                </Text>
                            </div>
                            {average && (
                                <div styleName={"styles.ratingBadge"}>
                                    <Rating
                                        readonly
                                        initialRating={average}
                                        emptySymbol={<IconStar type={"empty"} />}
                                        fullSymbol={<IconStar type={"fill"} />}
                                    />
                                    <Text
                                        align="left"
                                        as="p"
                                        fontWeight="medium"
                                        size="300"
                                        transform="none"
                                        color={tokens.text_default_text_primary}
                                    >
                                        {`${average} out of 5 (${total} ratings)`}
                                    </Text>
                                </div>
                            )}
                        </div>
                        <div styleName={"styles.carouselWrap"}>
                            {list.map((item, index) => (
                                <div styleName={"styles.testimonialCard"} key={index}>
                                    <div styleName={"styles.userName"}>
                                        {showImg && (
                                            <div styleName={"styles.customerImg"}>
                                                <img src={item.imgUrl} alt="customer" />
                                            </div>
                                        )}
                                        <Text
                                            align="left"
                                            as="p"
                                            fontWeight="semibold"
                                            size="250"
                                            transform="none"
                                            color={tokens.text_default_text_primary}
                                        >
                                            {item.fullName || item.customer_name}
                                        </Text>
                                    </div>

                                    {item.review_rating && (
                                        <div styleName={"styles.rattingWrapper"}>
                                            <div styleName="styles.ratingCount">
                                                <Text
                                                    align="left"
                                                    as="p"
                                                    fontWeight="semibold"
                                                    size="200"
                                                    transform="none"
                                                    color={tokens.text_default_text_primary}
                                                >
                                                    {item.review_rating}
                                                </Text>
                                                <Rating
                                                    readonly
                                                    initialRating={item.review_rating}
                                                    emptySymbol={<IconStar type={"empty"} />}
                                                    fullSymbol={<IconStar type={"fill"} />}
                                                />
                                            </div>

                                            {showDate && (
                                                <div styleName="styles.dateWrapper">
                                                    <Text
                                                        align="left"
                                                        as="p"
                                                        fontWeight="medium"
                                                        size="200"
                                                        transform="none"
                                                        color={tokens.text_default_text_secondary}
                                                    >

                                                        {(item.testimonialDate || item.created_at) &&
                                                    `
                                                ${getParticularDay(
                                                    new Date(
                                                        item.testimonialDate ||
                                                            item.created_at
                                                    )
                                                )}
                                                ${getMonth(
                                                    new Date(
                                                        item.testimonialDate ||
                                                            item.created_at
                                                    ),
                                                    true
                                                )},
                                                ${new Date(
                                                    item.testimonialDate ||
                                                        item.created_at
                                                ).getFullYear()}
                                            `}

                                                    </Text>
                                                </div>
                                            )}

                                        </div>
                                    )}
                                    <div styleName={"styles.textWrapper"}>
                                        <div styleName={"styles.titleSubtitle"}>
                                            {(item.testimonialTitle || item.title) && (
                                                <Text
                                                    align="left"
                                                    as="p"
                                                    fontWeight="semibold"
                                                    size="400"
                                                    transform="none"
                                                    color={tokens.text_default_text_primary}
                                                >
                                                    {`${item.testimonialTitle || item.title}`}
                                                </Text>
                                            )}
                                            <Text
                                                align="left"
                                                as="p"
                                                fontWeight="regular"
                                                size="250"
                                                transform="none"
                                                color={tokens.text_default_text_secondary}
                                            >
                                                {item.message || item.review_description}
                                            </Text>
                                        </div>
                                        <Text
                                            align="left"
                                            as="p"
                                            fontWeight="medium"
                                            size="250"
                                            transform="none"
                                            color={tokens.text_default_text_primary}
                                        >
                                        Sold {item.makeName || item.make}{" "}
                                            {item.modelName || item.model},{" "}
                                            {item.cityName || item.city}
                                        </Text>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div styleName="styles.paginationContainer">
                    {visiblePages.map((page, index) => {
                        if (page === "...") {
                            return <span key={index} styleName="styles.ellipsis">...</span>;
                        }
                        return (
                            <a
                                key={page}
                                href={generatePageLink(page)}
                                styleName={`styles.paginationBtn ${page === Number(currentPage) ? "styles.active" : ""}`}
                            >
                                {page}
                            </a>
                        );
                    })}
                </div>
            </div>
            <BreadcrumbList
                homeText={"Home"}
                onClickCallback={onBreadcrumbClick}
                list={computeBreadcrumbList()}
                isRevamped = {true}
                attachSchema={true}
            />
            {isSSR && <ReviewSchema reviews={list} averageRating={average} totalReviews={total} />}
        </>
    );
};

CustomerReviews.propTypes = {
    isSSR: PropTypes.bool,
    list: PropTypes.array,
    average: PropTypes.number,
    total: PropTypes.number,
    showImg: PropTypes.bool,
    showDate: PropTypes.bool,
    getCustomerReviewsConnect: PropTypes.func,
    history: PropTypes.object
};

export default CustomerReviews;
